import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { StateObject } from "../../redux/types"
import type { LocationsPickerState } from "./reducer"

export const getLocationsPickerStateObject = (state: StateObject): LocationsPickerState => state.locationsPicker

export const getSelectedLocationOverrideId = (state: StateObject): Maybe<string> =>
    getLocationsPickerStateObject(state).selectedLocationOverrideId

export const getSelectedLocationId = (state: StateObject): Maybe<string> =>
    getLocationsPickerStateObject(state).selectedLocationId
